
import { defineComponent } from 'vue'
import { mapGetters, mapState } from 'vuex'
import ResizeObserver from '@/components/ResizeObserver.vue'
import TutorialModal from '@/components/TutorialModal.vue'
import MessageModal from '@/components/common/MessageModal.vue'
import UserToolbar from '@/components/UserToolbar.vue'
import { AuthActionTypes } from '@/store/modules/auth/interfaces/action-types'
import { buildUserInfoFromSession } from '@/store/modules/auth/services/buildUserInfoFromSession'
import { LinksActionType } from '@/store/modules/links/interfaces'
import { setI18nLanguage } from '@/i18n'
import Error401Page from './pages/Error401Page.vue'
import BeforeLoginLayout from '@/components/layout/BeforeLoginLayout.vue'
import { LanguagesType } from '@/types'
import { HelpPagesActionType } from '@/store/modules/help-pages/interfaces'
import AppGlobalModal from '@/components/app/AppGlobalModal.vue'
import ModalComponent from './components/ModalComponent.vue'
import { AuthMutationTypes } from '@/store/modules/auth/interfaces/mutation-types'
import { RolePermissionDetails } from './store/modules/users/interfaces/IUser'
import { IAuthState } from './store/modules/auth/IAuthState'
import { IFetchSearchResponse } from '@/store/modules/main/intefaces/fetchSearch/IFetchSearchResponse'
import { IPortalHardCodeLink } from './store/modules/links/interfaces/IPortalHardCodeLink'
import { getValueByLabel } from './utils/permissions'
import AppLayout from '@/components/layout/AppLayout.vue'
import { getUnseenHelpPages } from './utils/newCapabilities'
import AlertModal from './components/AlertModal.vue'
import refreshAfterChangeLanguage from '@/mixins/refreshAfterChangeLanguage'
import ConsentModal from './components/ConsentModal.vue'

export default defineComponent({
  name: 'App',

  mixins: [refreshAfterChangeLanguage],

  components: {
    TutorialModal,
    Error401Page,
    MessageModal,
    UserToolbar,
    BeforeLoginLayout,
    ModalComponent,
    AppGlobalModal,
    ResizeObserver,
    AppLayout,
    AlertModal,
    ConsentModal
  },
  data: () => ({
    showTutorialModal: false,
    gigICode: '',
    gigIvToken: '',
    isPortalChrome: true,
    isLoaded: false,
    openModal: false,
    showFallbackModal: true,
    message: '',
    subMessage: '',
    searchValue: '',
    searchValues: [] as IFetchSearchResponse[],
    isErrorModal: true,
    activeLanguage: (localStorage.getItem('lang')) as LanguagesType,
    clientWidth: 0,
    showAlert: false,
    showConsentModal: false,
    content: {} as any,
    dictionary: {
      en: {
        createAnOrder: 'CREATE AN ORDER',
        createAnOrderIt: 'Create An Order',
        cart: 'MY CART',
        otherLinks: 'Other links',
        legalClause: 'Legal clause',
        backUp: 'Back up',
        menu: 'Menu',
        tutorial: 'Tutorial',
        search: 'Search',
        home: 'Homepage',
        profile: 'My Profile',
        contracts: 'Contracts',
        orders: 'Orders',
        history: 'History',
        savedOrders: 'Saved Orders',
        suggestedCart: 'Suggested Cart',
        catalog: 'Catalogue',
        products: 'Product Overview',
        favorites: 'My Favorites',
        favoritesMenu: 'MY FAVORITES',
        reporting: 'Reporting',
        myDocuments: 'My documents',
        marketingMaterials: 'Marketing Materials',
        news: 'News and Articles',
        newsEvents: 'News and Events',
        aboutPeroni: 'About Peroni',
        support: 'Support',
        faq: 'FAQ',
        knowledgeBase: 'Knowledge Base',
        supportTickets: 'Support Tickets',
        eLearning: 'Academy',
        skELearning: 'Academy',
        pubMenu: 'Menu Creator',
        skPubMenu: 'Menu Creator',
        emptiesManagement: 'Empties Management',
        contacts: 'Contacts',
        about: 'About us',
        cookies: 'Cookies and personal data protection',
        brands: 'Brands',
        productCode: 'Product code',
        createNewUser: 'Create New User',
        trainingLearning: 'Training & Learning',
        Unit: 'Unit',
        actions: {
          edit: 'My Profile',
          logout: 'Logout'
        },
        languages: {
          cs: 'Česky',
          en: 'English',
          de: 'Deutsch',
          it: 'Italiano',
          sk: 'Slovensky'
        },
        login: 'Login',
        notificationsEmpty: 'No notifications',
        termsOfUse: 'Terms of use',
        corporateInformation: 'Corporate Information',
        corporateGovernance: 'Corporate Governance',
        goToCart: 'Go To Cart',
        removeItem: 'Remove Item'
      },
      cs: {
        createAnOrder: 'Vytvořit objednávku',
        administration: 'Administrace',
        cart: 'Košík',
        home: 'Hlavní stránka',
        profile: 'Můj profil',
        contracts: 'Přehled smluv',
        orders: 'Objednávky',
        history: 'Historie objednávek',
        savedOrders: 'Uložené objednávky',
        suggestedCart: 'Návrh objednávky',
        catalog: 'Katalog',
        products: 'Přehled výrobků',
        favorites: 'Moje oblíbené',
        favoritesMenu: 'Moje oblíbené',
        reporting: 'Přehled odběrů',
        myDocuments: 'Moje dokumenty',
        marketingMaterials: 'Materiály pro Vás',
        news: 'Novinky a články',
        aboutPeroni: 'O Peroni',
        support: 'Podpora',
        faq: 'Otázky a odpovědi',
        knowledgeBase: 'O portálu',
        supportTickets: 'Kontaktujte nás',
        eLearning: 'Akademie První u zdroje',
        pubMenu: 'Prazdroj menu',
        otherLinks: 'Další odkazy',
        legalClause: 'Právní doložka',
        backUp: 'Zpět nahoru',
        menu: 'Menu',
        tutorial: 'Průvodce',
        search: 'Vyhledat',
        contacts: 'Kontakty',
        about: 'O nás',
        cookies: 'Cookies a ochrana osobních údajů',
        brands: 'Značky',
        productCode: 'kód produktu',
        createNewUser: 'Vytvořit nového uživatele',
        Unit: 'Balení',
        actions: {
          edit: 'Profil',
          logout: 'Odhlásit'
        },
        languages: {
          cs: 'Česky',
          en: 'English',
          de: 'Deutsch',
          it: 'Italiano',
          sk: 'Slovensky'
        },
        login: 'Přihlásit se',
        notificationsEmpty: 'Žádné notifikace',
        termsOfUse: 'Podmínky použití',
        goToCart: 'Košík',
        removeItem: 'Odstranit'
      },
      sk: {
        createAnOrder: 'Vytvoriť objednávku',
        administration: 'Administrace',
        cart: 'Košík',
        home: 'Hlavná stránka',
        profile: 'Môj profil',
        contracts: 'Prehľad zmlúv',
        orders: 'Objednávky',
        history: 'História objednávok',
        savedOrders: 'Uložené objednávky',
        suggestedCart: 'Odporúčaný tovar',
        catalog: 'Katalóg',
        products: 'Prehľad výrobkov',
        favorites: 'Moje obľúbené',
        favoritesMenu: 'Moje obľúbené',
        reporting: 'Prehľad odberov',
        myDocuments: 'Moje dokumenty',
        marketingMaterials: 'Materiály pre Vás',
        news: 'Novinky a články',
        aboutPeroni: 'O Peroni',
        support: 'Podpora',
        faq: 'Otázky a odpovede',
        knowledgeBase: 'O portáli',
        supportTickets: 'Kontaktujte nás',
        eLearning: 'Akadémia Prvý pri zdroji',
        skELearning: 'Akadémia Prvý pri zdroji',
        pubMenu: 'Prazdroj menu',
        skPubMenu: 'Prazdroj menu',
        otherLinks: 'Ďalšie odkazy',
        legalClause: 'Právna doložka',
        backUp: 'Späť hore',
        menu: 'Menu',
        tutorial: 'Sprievodca',
        search: 'Hľadať',
        contacts: 'Kontakty',
        about: 'O nás',
        cookies: 'Cookies a ochrana osobných údajov',
        brands: 'Značky',
        productCode: 'kód produktu',
        createNewUser: 'Vytvoriť nového užívateľa',
        Unit: 'Balenie',
        actions: {
          edit: 'Profil',
          logout: 'Odhlásiť'
        },
        languages: {
          cs: 'Česky',
          en: 'English',
          sk: 'Slovensky'
        },
        login: 'Prihlásiť sa',
        notificationsEmpty: 'Žiadne notifikácie',
        termsOfUse: 'Podmienky používania',
        goToCart: 'Košík',
        removeItem: 'Odstrániť'
      }
    },
    timeoutId: 0
  }),

  computed: {
    ...mapState('main', ['pageNotFound']),
    ...mapState('basket', ['id', 'items', 'progressBarMsg']),
    ...mapGetters('main', ['getPermissions']),
    portalHardCodeLink (): IPortalHardCodeLink[] {
      return this.$store.state.links.portalHardCodeLink?.results ?? []
    },
    total () {
      return this.$store.state.links.portalHardCodeLink.total
    },
    consentToBeApproved () {
      return this.$store.state.auth.consentToBeApproved
    },
    portalPageMenuLink () {
      return this.$store.state.links.portalPageMenuLink?.items ?? []
    },
    limit () {
      return this.$store.state.links.portalHardCodeLink.limit
    },
    queries () {
      return this.$store.state.catalog.queries
    },
    catalogPermission () {
      return this.checkPermission('Catalogue', {}).length !== 0
    },

    languages () {
      if (this.user.country === 'CZE' || window.location.hostname.includes('.cz')) {
        return ['cs', 'en']
      }

      if (this.user.country === 'SVK' || window.location.hostname.includes('.sk')) {
        return ['sk', 'en']
      }

      return ['en', this.activeLanguage].filter((x, index, self) => x != null && self.indexOf(x) === index)
    },

    user () {
      return this.$store.state.auth.user
    },

    isLoggedIn () {
      return this.user.isLoggedIn // && !!this.user.userValidation
    },
    isGigyaFallback () {
      return this.$store.state.auth.isGigyaFallback
    },
    isDeliveryDateFallback () {
      return this.$store.state.deliveryDates.isDeliveryDateFallback
    },
    fallbackSubMessage (): string {
      if (this.isGigyaFallback && !this.isDeliveryDateFallback) {
        return this.$t('At the moment, only standard orders can be placed, and My Profile section is unavailable. We\'re on it and expect to have everything back to normal shortly. Thanks for bearing with us.')
      }
      return this.$t('At the moment, only standard orders for the next working day can be placed. Some portal sections are unavailable. We\'re on it and expect to have everything back to normal shortly. Thanks for bearing with us.')
    },
    notAuthorized () {
      return this.$route.meta?.requireAuthentication && !this.isLoggedIn
    },
    allPermission () {
      return this.user.allAvailablePermission
    },
    helpPagesStore () {
      return this.$store.state.helpPages
    },
    customerRole () {
      return localStorage.getItem('customertype') || null
    },
    customerType (): RolePermissionDetails | undefined {
      if (this.user && this.user?.permissionSchema?.length > 0) {
        return this.user?.permissionSchema[0]?.rpDetails?.find((item: RolePermissionDetails) => item.customerType)
      }
      return undefined
    },
    alerts () {
      return this.$store.state.helpPages.alerts
    },
    isPOSAcademyUser () {
      return this.user.permissionSchema?.every(permission => permission.rpDetails.every(
        roleItem =>
          roleItem.rolename === 'POS Academy' ||
          roleItem.roleid === 'f5ab4859-9197-47e5-bc9e-097283c35d94'
      ))
    }
  },

  watch: {
    isLoggedIn: {
      handler (value) {
        if (value === true) {
          this.fetchPortalHardCodeLink()
          this.fetchPortalPageMenuLink()
        }
      }
    },
    activeLanguage: {
      async handler (value) {
        this.setMagentoStore(value)
        if (this.isLoggedIn) {
          this.fetchPortalHardCodeLink()
          this.fetchPortalPageMenuLink()
        }
      },
      immediate: true
    },

    consentToBeApproved: {
      handler (value) {
        if (value === true) {
          this.showConsentModal = true
        }
      },
      immediate: true

    },

    $route () {
      this.initFromRoute()
      this.getAlertContent()
    },

    progressBarMsg (value, oldValue) {
      if (oldValue !== value) {
        this.$store.commit('basket/SET_PROGRESS_BAR', value)
        return value
      }
    }
  },

  created () {
    this.initFromRoute()
  },

  async mounted () {
    if (window.location.hostname.includes('.cz') && this.activeLanguage !== 'en') {
      this.changeLanguage('cs')
    }

    if (window.location.hostname.includes('.sk') && this.activeLanguage !== 'en') {
      this.changeLanguage('sk')
    }

    this.checkGigyaReady()
    await this.dispatchAlerts()
    this.getAlertContent()
  },

  methods: {

    checkGigyaReady () {
      if (window.gigya) {
        window.gigya.hasSession().then(this.checkSession)
        window.gigya.socialize.addEventHandlers({
          onLogin: async (res: IAuthState) => {
            await this.updateUserInfo(res)
            await this.$store.dispatch('basket/CREATE_EMPTY_CART', { root: true })
            await this.AddUserToExternalDB(res.UID)
          }
        })
      } else {
        setTimeout(() => {
          this.checkGigyaReady()
        }, 100)
      }
    },

    initFromRoute () {
      this.isPortalChrome = !this.$route.meta?.noPortalChrome
      const urlParams = new URLSearchParams(window.location.search)
      this.gigICode = urlParams.get('gig_i_code') || ''
      this.gigIvToken = urlParams.get('gig_i_vToken') || ''
    },
    checkPermission (permission: string, value: Record<string, any>, additionalPremmision = true) {
      if (this.customerType) localStorage.setItem('customertype', this.customerType?.customerType)

      return this.allPermission?.includes(permission) &&
      additionalPremmision &&
      getValueByLabel(this.getPermissions(), permission)
        ? [value]
        : []
    },
    hasProductRecommendationPermission () {
      const hasPermission = this.allPermission.includes('Product Recommendation')
      if (hasPermission) {
        localStorage.setItem('productrecoenabled', '1')
      }

      return hasPermission
    },
    async dispatchHelpPages () {
      const customertype = this.customerType?.customerType || localStorage.getItem('customertype') || ''
      const uid = sessionStorage.getItem('uid')

      await this.$store.dispatch(
        HelpPagesActionType.FETCH_ALL_HELP_PAGES,
        { customertype, uid }
      )
    },
    async dispatchAlerts () {
      const customertype =
    this.customerType?.customerType ||
    localStorage.getItem('customertype') || ''

      const uid = sessionStorage.getItem('uid')

      await this.$store.dispatch(
        HelpPagesActionType.FETCH_ALERTS,
        {
          public: !this.isLoggedIn,
          customertype,
          uid
        }
      )
    },
    async AddUserToExternalDB (id: string) {
      await this.$store.dispatch('users/ADD_USER_TO_EXTERNAL_DB', { id })
    },
    openTutorialModal () {
      this.showTutorialModal = true
    },
    closeTutorialModal (displayTime?: any) {
      this.showTutorialModal = false
      this.showAlert = false
      const currentLocation = this.$route.name as string
      this.$gtm.trackEvent({ ecommerce: null })
      this.$gtm.trackEvent({
        event: 'banner_dismissed',
        promotion_id: this.content.id,
        promotion_name: this.content.name,
        page_location: window.location.href,
        page_path: currentLocation,
        event_timestamp: new Date().toISOString(),
        display_sequence: this.content.numberOfViews,
        display_duration_seconds: Math.floor((Date.now() - new Date(displayTime).getTime()) / 1000)
      })
    },
    closeConsentModal () {
      this.showConsentModal = false
    },
    changeLanguage (langCode: LanguagesType) {
      this.activeLanguage = langCode
      setI18nLanguage(langCode)
    },
    fetchPortalHardCodeLink () {
      const customertype = this.customerType?.customerType || localStorage.getItem('customertype') || ''
      const uid = sessionStorage.getItem('uid')

      this.$store.dispatch(
        LinksActionType.FETCH_PORTAL_HARD_CODE_LINK,
        { customertype, uid }
      )
    },
    fetchPortalPageMenuLink () {
      const customertype =
    this.customerType?.customerType ||
    localStorage.getItem('customertype') || ''

      const uid = sessionStorage.getItem('uid')

      this.$store.dispatch(
        LinksActionType.FETCH_PAGE_MENU_LINK,
        { customertype, uid }
      )
    },

    getLinkByName (name: string) {
      const linkObj = this.portalHardCodeLink.find((link) => link.name === name)
      return linkObj ? { url: linkObj.url, label: linkObj.label } : { url: '', label: '' }
    },

    /**
     * Method to update logged in user info into vuex store
     * @param res
     */
    async updateUserInfo (res: IAuthState) {
      try {
        // Store basic user info for analytics
        sessionStorage.setItem('uid', res.UID)
        sessionStorage.setItem('getUserInfoResponse', JSON.stringify(res))
        if (res?.groups) {
          sessionStorage.setItem('userInfoBackUp', JSON.stringify(buildUserInfoFromSession(res)))
        }
        localStorage.removeItem('fromVerification')

        // Commit auth user to Vuex store (this will set id_token if present)
        this.$store.commit('SET_AUTH_USER', res)

        // ✅ Ensure id_token exists in sessionStorage
        const idToken = sessionStorage.getItem('id_token')
        if (!idToken) {
          console.warn('id_token missing after SET_AUTH_USER, fetching new JWT…')
          await new Promise<void>((resolve) => {
            window.gigya.accounts.getJWT({
              callback: (jwtRes: any) => {
                if (jwtRes.errorCode === 0 && jwtRes.id_token) {
                  console.info('getJWT success, saving id_token')
                  sessionStorage.setItem('id_token', jwtRes.id_token)
                  // optional: keep Vuex state in sync
                  this.$store.commit('SET_GENERATE_TOKEN', jwtRes.id_token)
                } else {
                  console.error('getJWT failed', jwtRes)
                }
                resolve()
              }
            })
          })
        }

        // Setup session timeout if user is logged in
        if (this.isLoggedIn) {
          this.setupTimers()
        }
        // Fetch full user info
        await this.$store.dispatch(AuthActionTypes.GET_USER_INFO, { id: res.UID }).then(() => {
          this.hasProductRecommendationPermission()
        })

        // Defensive: wait until user object is fully populated
        if (!this.user || typeof this.user !== 'object' || !('userValidation' in this.user)) {
          console.warn('User object not fully loaded. Skipping logout check.')
          return
        }

        // Check user validation and redirect if necessary
        if (!this.user.userValidation && !this.$route.meta?.isUserVerification && !this.$store.state.auth.isGigyaFallback) {
          this.userLogout()
          return
        }

        this.updateLanguage()

        // POS academy check
        if (!!this.user.userValidation && !this.$route.meta?.isUserVerification) {
          await this.checkPOSAcademyUser()
        }

        this.checkLoginModal()

        // Fetch orderable units config if needed
        const customerType = localStorage.getItem('customertype')
        const shippingMethod = localStorage.getItem('shippingMethod')
        if (customerType && shippingMethod) {
          this.$store.dispatch(
            'main/FETCH_ORDERABLE_UNITS_CONFIG',
            {
              customerType,
              orderType: shippingMethod
            },
            { root: true }
          )
        }
      } catch (error) {
        console.error('Error in updateUserInfo:', error)
      }
    },

    updateLanguage () {
      if (this.user.country === 'CZE' && this.activeLanguage !== 'en') {
        this.changeLanguage('cs')
      }

      if (this.user.country === 'SVK' && this.activeLanguage !== 'en') {
        this.changeLanguage('sk')
      }

      if (this.user.country === 'POL' && this.activeLanguage !== 'en') {
        this.changeLanguage('en')
      }

      // Set Magento store
      this.setMagentoStore(this.activeLanguage)
    },

    async refresh () {
      await this.dispatchAlerts()
      this.getAlertContent()
    },

    async checkLoginModal () {
      // Help pages tutorial logic
      await this.dispatchAlerts()
      this.getAlertContent()

      if (!this.helpPagesStore?.helpPages?.length) {
        await this.dispatchHelpPages()
      }
      const unseenHelpPages = getUnseenHelpPages(
        this.helpPagesStore.helpPages?.filter(h => h?.newCapability === true) || [],
        this.user.UID
      )
      if (
        this.user.firstLogin === true ||
      this.user.showTutorial > 0 ||
      this.user.showTutorial === null ||
      unseenHelpPages.length > 0
      ) {
        this.openTutorialModal()
      }
    },
    checkPOSAcademyUser () {
      if (this.isPOSAcademyUser) {
        window.gigya.fidm.saml.initSSO({
          spName: this.user.country === 'SVK' ? 'skELearning' : 'eLearning',
          redirectURL: this.user.country === 'SVK' ? this.getLinkByName('skELearning').url : this.getLinkByName('eLearning').url
        })
      }
    },
    /**
     * Method to initiate logout action
     * on click action of logout button
     */
    userLogout () {
      sessionStorage.removeItem('uid')
      sessionStorage.removeItem('imp_usr')
      sessionStorage.removeItem('isFromFavoritePage')
      const params = {
        UID: this.user.UID,
        callback: this.handleLogout
      }
      window.gigya.accounts.logout(params)
    },
    /**
     * Method to perform action after user logs out
     * Navigate user to home page
     */
    handleLogout () {
      localStorage.removeItem('deliveryDate')
      localStorage.removeItem('exceptiondate')
      localStorage.removeItem('standardDeliveryDate')
      localStorage.removeItem('shippingMethod')
      localStorage.removeItem('shipToId')
      this.$store.dispatch('logout')
      window.location.href = '/login'
    },
    /**
     * Method to check user session if it exist
     * if it does not exist then redirect user to login page
     * @param sessionExist
     */
    async checkSession (sessionExist: boolean) {
      try {
        if (sessionExist) {
          window.gigya.socialize.getUserInfo({ callback: this.updateUserInfo })
        } else if (!this.$route.meta?.isUserVerification && this.$route.meta?.requireAuthentication) {
          this.$navigate('/login')
        }
      } catch (error) {
        console.error('Error in checkSession:', error)
      } finally {
        this.isLoaded = true
      }
    },

    setMagentoStore (language: string) {
      if (this.user.country === 'SVK' || (this.user.country == null && window.location.hostname.includes('.sk'))) {
        localStorage.setItem('store', `LivePortal_SK_${language}`)
      }
      if (this.user.country === 'CZE' || (this.user.country == null && window.location.hostname.includes('.cz'))) {
        localStorage.setItem('store', `LivePortal_CZ_${language}`)
      }
      if (this.user.country === 'POL' || (this.user.country == null && window.location.hostname.includes('.cz'))) {
        localStorage.setItem('store', `LivePortal_PL_${language}`)
      }

      if (!(this.user.country == null || this.user.country === '') && !this.$store.state.auth.isLanguageLoaded) {
        this.$store.commit(AuthMutationTypes.SET_LANGUAGE_LOADED, true)
      }
    },

    onResizePortal ({ height }: { height: number }) {
      this.clientWidth = document.querySelector('body')?.clientWidth || height
    },
    startTimer () {
      this.timeoutId = setTimeout(this.userLogout, 900000)
    },
    resetTimer () {
      clearTimeout(this.timeoutId)
      this.startTimer()
    },
    getAlertContent () {
      const availableAlert = this.$store.state.helpPages.alerts as any
      if (availableAlert?.length > 0) {
        const currentLocation = this.$route.name as string

        const alertForCurrentPage = availableAlert.find((item: any) => {
          const availablePages = item.portalSections?.map((section: any) => section.name) || []
          return availablePages.includes(currentLocation)
        })

        const storedAlerts = localStorage.getItem('alerts')
        const alreadyShownAlerts =
      storedAlerts && JSON.parse(storedAlerts || '[]')

        const alreadyShownForCurrentPage = alreadyShownAlerts?.find(
          (alert: { id: string; page: string; confirmationNeeded: boolean }) => {
            return alert.id === alertForCurrentPage?.id && alert.page === currentLocation
          }
        )

        if (alertForCurrentPage && !alreadyShownForCurrentPage) {
          this.content = alertForCurrentPage
          this.$gtm.trackEvent({ ecommerce: null })

          this.$gtm.trackEvent({
            event: 'view_promotion',
            promotion_id: this.content.id,
            promotion_name: this.content.name,
            page_location: window.location.href,
            page_path: currentLocation,
            event_timestamp: new Date().toISOString(),
            display_timestamp: new Date().toISOString(),
            display_sequence: this.content.numberOfViews
          })
          this.showAlert = true
        } else {
          this.content = null
          this.showAlert = false
        }
      }
    },

    setupTimers () {
      document.addEventListener('keypress', this.resetTimer, false)
      document.addEventListener('mousemove', this.resetTimer, false)
      document.addEventListener('mousedown', this.resetTimer, false)
      document.addEventListener('touchmove', this.resetTimer, false)

      this.startTimer()
    }
  }
})
